import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const login = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #18182e;
  min-height: 100vh;

  > :last-child {
    margin-bottom: 50px;
  }

  > div,
  form {
    width: 100%;
    max-width: 450px;
  }
`;

export const previousStep = css`
  margin-top: 20px;

  > button {
    color: ${colors.white};
    align-self: flex-start;

    :hover {
      color: ${colors.white};
      text-decoration: underline;
    }
  }
`;

export const nextStep = css`
  margin-top: 40px;
  align-self: flex-end;
  color: ${colors.white.DEFAULT};
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }

  svg {
    margin-right: 5px;
  }
`;

export const logo = css`
  height: 100px;
  margin-top: 50px;

  color: ${colors.white.DEFAULT};
`;

export const heading = css`
  color: ${colors.white.DEFAULT};
  font-size: 24px;
  margin-top: 30px;
`;

export const loading = css`
  width: 150px;
  height: 20px;
  margin-top: 30px;

  g {
    fill: ${colors.white.DEFAULT};
  }
`;

export const form = css`
  position: relative;
  display: flex;
  flex-direction: column;

  > button {
    margin-top: 40px;
  }
`;

export const formBodyText = css`
  color: ${colors.white.DEFAULT};
  margin-top: 20px;
  text-align: center;
`;

export const input = css`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  > div:first-child {
    color: ${colors.white.DEFAULT};
    margin-bottom: 5px;
  }
`;

export const inputError = css`
  position: absolute;
  left: 0;
  top: calc(100% + 5px);
`;

export const passwordForm = css`
  > span {
    display: block;
    margin: 30px 0;
  }

  > form {
    > div,
    button {
      width: 100%;
    }
  }
`;
